<template>
  <span
    v-if="singleLine"
    class="w-full whitespace-nowrap overflow-hidden! text-ellipsis! block"
  >
    {{
      props.content
        .map(item => (typeof item === 'string' ? item : item[1]))
        .join('')
    }}
  </span>
  <div v-else>
    <template
      v-for="(item, index) in props.content"
      :key="index"
    >
      <span v-if="typeof item === 'string'">{{ item }}</span>
      <!-- prettier-ignore -->
      <ruby v-else-if="item[0] === 'hanzi'">
        {{ item[1] }}<rt>{{ convert(item[2]) }}</rt>
      </ruby>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { StringOrHanzi } from '@/types/model'
import { convert } from 'pinyin-pro'

const props = defineProps<{
  content: StringOrHanzi[]
  singleLine?: boolean
}>()
</script>

<style scoped>
rt {
  font-size: 0.8em;
}
ruby {
  margin: 0 2px;
}
</style>
